module.exports = __webpack_public_path__ + "105ddf5c6a7d383879695940c3df7ca9.usdz";